export default class BaseModel {
    uuid: string = crypto.randomUUID();
}